// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const navigateToNewMemberPage = (navigate, location) => () => {
  navigate(`/management/new-members${location.search || ''}`)
}
